import { useEffect, useState } from 'react';

// Swiper con `loop` + `breakpoints` resuelve el breakpoint client-side casi
// al instante, antes de que termine la hidratación, y el servidor siempre
// renderiza con los props base — eso produce un mismatch real. Los carousels
// que combinan loop+breakpoints difieren el montaje al cliente con este hook.
const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return isClient;
};

export default useIsClient;
